<template>
<div class="main-screen">
    <!-- 中间地图区域 -->
    <div class="center-map">
        <div class="map-container">
            <!-- 顶部指标数字 -->
            <div class="top-metrics">
                <div class="metric-card" v-for="(stat, index) in topStats" :key="index">
                    <div class="metric-value">{{ stat.value }}</div>
                    <div class="metric-label">{{ stat.label }}</div>
                </div>
            </div>
            <PipeNetworkMap ref="mapComponent" />
        </div>

        <!-- 右侧数据看板 -->
        <div class="right-panel">
            <!-- 管网监测数据 -->
            <div class="data-section">
                <div class="section-header">
                    <i class="icon-monitor"></i>
                    <span>{{ $t('管网监测数据') }}</span>
                </div>
                <div class="monitoring-table">
                    <table>
                        <thead>
                            <tr>
                                <th>{{ $t('监测点') }}</th>
                                <th>{{ $t('压力(MPa)') }}</th>
                                <th>{{ $t('流量(m³/h)') }}</th>
                                <th>{{ $t('水质合格率') }}</th>
                                <th>{{ $t('状态') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in monitoringData" :key="index">
                                <td>{{ item.name }}</td>
                                <td :class="item.pressure > 0.5 ? 'normal' : 'warning'">{{ item.pressure }}</td>
                                <td>{{ item.flow }}</td>
                                <td>{{ item.quality }}%</td>
                                <td>
                                    <span class="status-indicator" :class="item.status">
                                        <i v-if="item.status === 'warning'" class="icon-warning"></i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- 漏损率排行 -->
            <div class="data-section">
                <div class="section-header">
                    <i class="icon-ranking"></i>
                    <span>{{ $t('漏损率排行') }}</span>
                </div>
                <div class="leakage-ranking">
                    <div class="rank-item" v-for="(item, index) in leakageRanking" :key="index">
                        <span class="rank-number">{{ index + 1 }}</span>
                        <span class="region-name">{{ item.region }}</span>
                        <div class="progress-bar">
                            <div class="progress-fill" :style="{ width: item.rate + '%' }"></div>
                        </div>
                        <span class="rate-value">{{ item.rate }}%</span>
                    </div>
                </div>
            </div>

            <!-- 近7日夜间最小流量 -->
            <div class="data-section">
                <div class="section-header">
                    <i class="icon-trend"></i>
                    <span>{{ $t('近7日夜间最小流量') }}</span>
                </div>
                <div class="trend-chart">
                    <MinFlowChart :data="minFlowData" />
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import PipeNetworkMap from './modules/main/PipeNetworkMap.vue'
import MinFlowChart from './modules/main/MinFlowChart.vue'

export default {
    name: 'Main',
    components: {
        PipeNetworkMap,
        MinFlowChart
    },
    data() {
        return {
            topStats: [{
                    value: '1,247.5',
                    label: this.$t('管线总长(km)')
                },
                {
                    value: '2,856',
                    label: this.$t('压力仪数')
                },
                {
                    value: '1,432',
                    label: this.$t('流量计')
                },
                {
                    value: '98.7%',
                    label: this.$t('覆盖率')
                }
            ],
            monitoringData: [{
                    name: this.$t('东区泵站'),
                    pressure: 0.45,
                    flow: 1250,
                    quality: 99.2,
                    status: 'normal'
                },
                {
                    name: this.$t('西水厂'),
                    pressure: 0.38,
                    flow: 980,
                    quality: 98.7,
                    status: 'normal'
                },
                {
                    name: this.$t('南区管网'),
                    pressure: 0.42,
                    flow: 1560,
                    quality: 97.5,
                    status: 'warning'
                },
                {
                    name: this.$t('北区节点'),
                    pressure: 0.52,
                    flow: 890,
                    quality: 99.1,
                    status: 'normal'
                },
                {
                    name: this.$t('中央主干'),
                    pressure: 0.48,
                    flow: 2100,
                    quality: 98.9,
                    status: 'normal'
                }
            ],
            leakageRanking: [{
                    region: this.$t('城东区域'),
                    rate: 15.2
                },
                {
                    region: this.$t('城南区域'),
                    rate: 12.8
                },
                {
                    region: this.$t('城西区域'),
                    rate: 10.5
                },
                {
                    region: this.$t('城北区域'),
                    rate: 8.3
                },
                {
                    region: this.$t('中央区域'),
                    rate: 6.7
                }
            ],
            minFlowData: [{
                    day: this.$t('周一'),
                    value: 1250
                },
                {
                    day: this.$t('周二'),
                    value: 1180
                },
                {
                    day: this.$t('周三'),
                    value: 1320
                },
                {
                    day: this.$t('周四'),
                    value: 1150
                },
                {
                    day: this.$t('周五'),
                    value: 1080
                },
                {
                    day: this.$t('周六'),
                    value: 950
                },
                {
                    day: this.$t('周日'),
                    value: 890
                }
            ]
        }
    }
}
</script>

<style lang="less" scoped>
.main-screen {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
    color: #ffffff;
    overflow: hidden;
}

/* 顶部指标数字 */
.top-metrics {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
    padding: 20px;
    background: rgba(0, 0, 0, 0.7);
    border: 1px solid rgba(0, 255, 200, 0.3);
    border-radius: 12px;
    backdrop-filter: blur(10px);
    z-index: 100;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

.metric-card {
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(0, 255, 200, 0.3);
    border-radius: 12px;
    padding: 20px 30px;
    text-align: center;
    transition: all 0.3s ease;
    min-width: 150px;

    &:hover {
        border-color: rgba(0, 255, 200, 0.5);
        box-shadow: 0 0 20px rgba(0, 255, 200, 0.2);
        transform: translateY(-2px);
    }

    .metric-value {
        font-size: 28px;
        font-weight: bold;
        color: #00ffc8;
        margin-bottom: 8px;
        text-shadow: 0 0 10px rgba(0, 255, 200, 0.5);
    }

    .metric-label {
        font-size: 14px;
        color: #cccccc;
    }
}

/* 中间地图区域 */
.center-map {
    flex: 1;
    position: relative;
    margin: 0;
    height: 100%;
    width: 100%;
}

.map-container {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

/* 右侧数据看板 */
.right-panel {
    position: absolute;
    top: 100px;
    right: 20px;
    width: 360px;
    max-height: calc(100% - 120px);
    background: rgba(20, 20, 20, 0.8);
    border: 1px solid rgba(0, 255, 200, 0.2);
    border-radius: 12px;
    padding: 20px;
    backdrop-filter: blur(10px);
    display: flex;
    flex-direction: column;
    gap: 15px;
    overflow: hidden;
}

.data-section {
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(0, 255, 200, 0.2);
    border-radius: 12px;
    padding: 15px;
    transition: all 0.3s ease;
    flex: 1;
    min-height: 0;

    &:hover {
        border-color: rgba(0, 255, 200, 0.4);
        box-shadow: 0 0 15px rgba(0, 255, 200, 0.2);
    }
}

.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding-bottom: 5px;
    border-bottom: 1px solid rgba(0, 255, 200, 0.2);

    i {
        color: #00ffc8;
        margin-right: 8px;
        font-size: 14px;
    }

    span {
        font-size: 14px;
        font-weight: bold;
        color: #00ffc8;
    }
}

/* 监测数据表格 */
.monitoring-table {
    overflow-x: auto;
    flex: 1;

    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 11px;

        th,
        td {
            padding: 4px 2px;
            text-align: left;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            line-height: 1.2;
        }

        th {
            color: #00ffc8;
            font-weight: bold;
            font-size: 10px;
        }

        td {
            color: #cccccc;

            &.normal {
                color: #00ffc8;
            }

            &.warning {
                color: #ffaa00;
            }
        }
    }
}

.status-indicator {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;

    &.normal {
        background: #00ffc8;
    }

    &.warning {
        background: #ffaa00;
    }
}

.icon-warning {
    color: #ffaa00;
    font-size: 12px;
}

/* 漏损率排行 */
.leakage-ranking {
    .rank-item {
        display: flex;
        align-items: center;
        margin-bottom: 6px;

        .rank-number {
            width: 16px;
            height: 16px;
            background: rgba(0, 255, 200, 0.2);
            border: 1px solid rgba(0, 255, 200, 0.4);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 10px;
            margin-right: 8px;
        }

        .region-name {
            flex: 1;
            font-size: 11px;
            color: #cccccc;
        }

        .progress-bar {
            flex: 2;
            height: 4px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 2px;
            margin: 0 8px;
            overflow: hidden;

            .progress-fill {
                height: 100%;
                background: linear-gradient(90deg, #00ffc8, #ffaa00);
                transition: width 0.3s ease;
            }
        }

        .rate-value {
            font-size: 11px;
            color: #ffaa00;
            font-weight: bold;
        }
    }
}

/* 趋势图 */
.trend-chart {
    height: 180px;
    padding: 5px 0;
    flex: 1;
}

/* 响应式设计 */
@media (max-width: 1440px) {
    .top-metrics {
        gap: 20px;
        padding: 15px;
    }

    .metric-card {
        padding: 15px 20px;
        min-width: 120px;
    }

    .metric-value {
        font-size: 24px;
    }

    .right-panel {
        width: 320px;
        right: 15px;
    }

    .center-map {
        margin: 15px;
        margin-right: 335px;
    }
}

@media (max-width: 1200px) {
    .top-metrics {
        flex-wrap: wrap;
        gap: 15px;
    }

    .metric-card {
        padding: 12px 16px;
        min-width: 100px;
    }

    .metric-value {
        font-size: 20px;
    }

    .right-panel {
        width: 100%;
        height: 250px;
        position: relative;
        top: 0;
        right: 0;
        margin: 15px;
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;

        .data-section {
            min-width: 300px;
            margin: 0 10px;
            flex: 1;
        }
    }

    .center-map {
        margin: 15px;
        margin-right: 15px;
    }
}

/* 自定义滚动条 */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar-thumb {
    background: rgba(0, 255, 200, 0.3);
    border-radius: 3px;

    &:hover {
        background: rgba(0, 255, 200, 0.5);
    }
}
</style>
